/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Infinite Options by ShopPad - Hide product bundle data on AJAX cart
Handlebars.registerHelper("ifDoesNotContain", function(string, substring, options) {
  return (string.indexOf(substring) < 0) ? options.fn(this) : "";
});